import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from '@api/api';
import { selectPlatformEnvironmentName } from '@store/slices/runtimeConfig/runtimeConfigSlice';

export interface FeatureFlagsResponse {
  environment: string;
  flags: Record<string, boolean>;
}

export const featureFlagsApi = createApi({
  reducerPath: 'featureFlagsApi',
  baseQuery: axiosBaseQuery(),
  endpoints: builder => ({
    getFeatureFlags: builder.query<FeatureFlagsResponse, void>({
      queryFn: async (_arg, api, _extraOptions, baseQuery) => {
        const platformEnvironment = selectPlatformEnvironmentName(api.getState() as never);
        const result = await baseQuery({
          url: '/feature-flags',
          method: 'GET',
          params: { environment: platformEnvironment },
        });

        if ('error' in result) {
          return { error: result.error };
        }

        return { data: result.data as FeatureFlagsResponse };
      },
    }),
  }),
});

export const { useGetFeatureFlagsQuery } = featureFlagsApi;
